import { Routes, Route } from "react-router-dom";
import ListPropertyResaleVibe from "../Components/Property Resale Vibe/listPropertyResaleVibe";
import AddPropertyResaleVibe from "../Components/Property Resale Vibe/addPropertyResaleVibe";
import EditPropertyResaleVibe from "../Components/Property Resale Vibe/editPropertyResaleVibe";
// import ViewPropertyResaleVibe from "../Components/PropertyResaleVibe/ViewPropertyResaleVibe";

const PropertyResaleVibeRoutes = () => {
  return (
    <Routes>
      <Route path="/resale_vibe" element={<ListPropertyResaleVibe />} />
      
      {/* <Route path="/resale_vibe/list" element={<ListPropertyResaleVibe />} /> */}
      <Route path="/resale_vibe/add" element={<AddPropertyResaleVibe />} />
      <Route path="/resale_vibe/edit/:id" element={<EditPropertyResaleVibe />} />
      {/* <Route path="/resale_vibe/view/:id" element={<ViewPropertyResaleVibe />} /> */}
     
    </Routes>
  );
};

export default PropertyResaleVibeRoutes;